import React, { useContext, useEffect, useState } from 'react';
import { Row, Col, Stack, Image } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import 'assets/styles/common.scss';
import { LocaleContext } from 'routes/Router';
import { FormattedMessage } from 'react-intl';
import ArrowLeftIcon from 'assets/images/WithoutLogin/arrow-left.svg';
import CallIcon from 'assets/images/Dashboard/call.svg';
import MailIcon from 'assets/images/Dashboard/mail.svg';
import ClockIcon from 'assets/images/Dashboard/clock.svg';
import CalerderIcon from 'assets/images/Dashboard/calendar.svg';
import { doctorAppointments } from 'routes/AppUrls';
import DefaultImage from 'assets/images/Dashboard/default-list.svg';
import HospitalIcon from 'assets/images/Dashboard/doctor-hospital.svg';
import VideoCallCameraIcon from 'assets/images/Dashboard/Video_Call.svg';
import ReusableButton from 'components/commom/Button';
import { useDispatch, useSelector } from 'react-redux';
import { getAppointmentDetail } from 'store/getAppointmentDetail/getAppointmentDetailAcition';
import { ClearTokenRedirectLogin } from 'utils/general';
import moment from 'moment';
import { getVedioToken } from 'store/VedioCallToken/VedioCallTokenAction';
import AgoraRTC from 'agora-rtc-sdk-ng';
import MicroPhoneOn from 'assets/images/Dashboard/MicrophoneOn.svg';
import MicroPhoneOff from 'assets/images/Dashboard/MicrophoneOff.svg';
import VedioOn from 'assets/images/Dashboard/VideoCameraOn.svg';
import VedioOff from 'assets/images/Dashboard/VideoCameraOff.svg';
import DemoVedio from 'assets/images/Dashboard/demi-vedio-2.svg';
import { updateRequestDetail } from 'store/updateRequestStatus/updateRequestStatusAction';
import Shimmer from 'components/commom/Shimmer';
import MuiBreadcrumbs from 'components/commom/MuiBreadcrumbs';
import CommonToast from 'components/commom/CommonToast';
import { getMethodWithToken } from 'utils/services/apiService';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';

const UpcomingDetails = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { locale } = useContext(LocaleContext);
  const { showToast } = CommonToast();
  const [appointmentUpcomingDetail, setAppointmentUpcomingDetail] =
    useState('');
  const [client, setClient] = useState(null);
  const [localTracks, setLocalTracks] = useState({ audio: null, video: null });
  const [remoteUsers, setRemoteUsers] = useState([]);
  const [isAudioEnabled, setIsAudioEnabled] = useState(true);
  const [isVideoEnabled, setIsVideoEnabled] = useState(true);
  const [showVedio, setShowVedio] = useState(false);
  const [images, setImages] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);

  const appId = '4093a693a9244dda827a362965e732e1';

  const appointmentDetailReducer = useSelector(
    (state) => state?.getAppointmentDetailReducer?.loading
  );

  const vedioReducer = useSelector(
    (state) => state?.getVedioCallReducer?.loading
  );

  const upcomingId = useSelector(
    (state) => state?.basicDetailsValueReducer?.upcomingId
  );

  const breadcrumbsList = [
    {
      title: <FormattedMessage id="Appointments" />,
      Link: '',
      isDisbale: true,
    },
    {
      title: <FormattedMessage id="Appointment Details" />,
      Link: '',
      isDisbale: false,
    },
  ];

  useEffect(() => {
    getUpcomingDetail();

    const agoraClient = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
    setClient(agoraClient);

    agoraClient.on('user-published', async (user, mediaType) => {
      await agoraClient.subscribe(user, mediaType);
      if (mediaType === 'video') {
        user.videoTrack.play(`remote-${user.uid}`);
      }
      if (mediaType === 'audio') {
        user.audioTrack.play();
      }
      setRemoteUsers((prev) => [...prev, user]);
    });

    agoraClient.on('user-unpublished', (user) => {
      setRemoteUsers((prev) => prev.filter((u) => u.uid !== user.uid));
    });

    return () => {
      agoraClient.leave();
      if (localTracks.audio) localTracks.audio.close();
      if (localTracks.video) localTracks.video.close();
    };
  }, []);

  const getUpcomingDetail = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleFetchImages(res);
        setAppointmentUpcomingDetail(res?.data);
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    dispatch(getAppointmentDetail(external, upcomingId));
  };

  const handleFetchImages = async (res) => {
    setImageLoading(true);
    const fetchedImages = await Promise.all(
      res?.data?.attachments?.map(async (item) => {
        const url = item.image.replace(process.env.REACT_APP_BASE_URL, '');
        const res = await getMethodWithToken(url, true);
        if (res?.status === 200 && res?.data) {
          const blob = new Blob([res.data], { type: 'image/jpeg' });
          setImageLoading(false);
          return {
            id: item.id,
            image: URL.createObjectURL(blob),
          };
        } else {
          console.error('Image fetch failed:', res?.status);
          setImageLoading(false);
          return null;
        }
      })
    );
    setImages(fetchedImages.filter(Boolean));
  };

  const startVideoCall = async () => {
    const external = {
      run: true,
      handleFunction: async (res) => {
        try {
          setShowVedio(true);
          await client.join(
            appId,
            res?.data?.channel_name,
            res?.data?.token,
            res?.data?.uuid
          );
          const [audioTrack, videoTrack] =
            await AgoraRTC.createMicrophoneAndCameraTracks();
          setLocalTracks({ audio: audioTrack, video: videoTrack });
          videoTrack.play('local-stream');
          await client.publish([audioTrack, videoTrack]);
        } catch (err) {
          console.error('Error starting video call:', err);
        }
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      appointment_id: upcomingId,
    };
    dispatch(getVedioToken(external, body));
  };

  const endVideoCall = async () => {
    try {
      setShowVedio(false);
      completeConsultation();
      await client.leave();
      if (localTracks.audio) localTracks.audio.close();
      if (localTracks.video) localTracks.video.close();
      setLocalTracks({ audio: null, video: null });
      setRemoteUsers([]);
    } catch (err) {
      console.error('Error ending video call:', err);
    }
  };

  const toggleAudio = () => {
    if (localTracks.audio) {
      if (isAudioEnabled) {
        localTracks.audio.setEnabled(false);
      } else {
        localTracks.audio.setEnabled(true);
      }
      setIsAudioEnabled(!isAudioEnabled);
    }
  };

  const toggleVideo = () => {
    if (localTracks.video) {
      if (isVideoEnabled) {
        localTracks.video.setEnabled(false);
      } else {
        localTracks.video.setEnabled(true);
      }
      setIsVideoEnabled(!isVideoEnabled);
    }
  };

  const completeConsultation = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        navigate(doctorAppointments(locale));
      },
      authorize: true,
      handleAuthorizeFunction: (res) => {
        ClearTokenRedirectLogin(navigate);
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };
    let body = {
      appointment_id: upcomingId,
      is_doctor_completed_consultation: true,
    };
    dispatch(updateRequestDetail(external, body));
  };

  return (
    <Row className="bc-FEF9F6 m-0 p-0">
      <Col
        className={
          locale === 'en'
            ? 'commonEnContainer lg:ml-left'
            : 'commonArContainer lg:mr-right'
        }
      >
        {!showVedio ? (
          <>
            {/* <div className="flex pb-16">
              <div className="fs-12 lh-24 fc-998A7B family_outfit_regular_400">
                Appointments
              </div>
              <div className="pl-04 flex items-center">
                <Image src={requestCheck} alt="icon" />
              </div>
              <div className="pl-04 fs-12 fc-242E39 lh-24 family_outfit_semiBold_600">
                Appointment Details
              </div>
            </div> */}
            <MuiBreadcrumbs size="12" list={breadcrumbsList} />

            <div className="mt-10">
              <Row className="bc-FFFFFF m-0 p-24 mt-3 border-1 bColor-EFE3D7 m-0">
                <Col xs={12} md={12} className="p-0">
                  <Stack
                    direction="horizontal"
                    gap={2}
                    className="items-center"
                  >
                    <Image
                      src={ArrowLeftIcon}
                      alt="icon"
                      style={{ height: '24px', width: '24px' }}
                      className="cursor-pointer"
                      onClick={() => navigate(-1)}
                    />
                    {appointmentDetailReducer ? (
                      <Shimmer width="250px" height="20px" />
                    ) : (
                      <div className="fs-16 lh-16 fc-292D32 family_outfit_medium_500">
                        <FormattedMessage id="Appointment no." />
                        {appointmentUpcomingDetail?.booking_id}
                      </div>
                    )}
                  </Stack>
                </Col>

                <Col
                  xs={12}
                  md={12}
                  className="mt-4 border-b pb-4 p-0 bColor-D6DDE6"
                >
                  <Row>
                    <Col xs={12} md={5} className="">
                      <Stack
                        direction="horizontal"
                        gap={3}
                        className="flex items-start"
                      >
                        {appointmentDetailReducer ? (
                          <Shimmer
                            width="88px"
                            height="88px"
                            borderRadius="50%"
                          />
                        ) : (
                          <Image
                            src={
                              appointmentUpcomingDetail?.patient
                                ?.profile_pic !== ''
                                ? appointmentUpcomingDetail?.patient
                                    ?.profile_pic
                                : DefaultImage
                            }
                            alt={'icon'}
                            style={{
                              height: '88px',
                              width: '88px',
                              borderRadius: '50%',
                            }}
                          />
                        )}
                        <div>
                          <div className="fs-18 lh-2268 fc-202224 family_outfit_medium_500">
                            {appointmentDetailReducer ? (
                              <Shimmer width="150px" height="20px" />
                            ) : (
                              appointmentUpcomingDetail?.patient?.full_name
                            )}
                          </div>
                          <div className="pt-8 fs-14 fc-998A7B family_outfit_regular_400">
                            ID:
                            <span className="fc-3C3C3C family_outfit_medium_500">
                              {appointmentUpcomingDetail?.patient?.patient_id}
                            </span>
                          </div>
                        </div>
                      </Stack>
                    </Col>
                    <Col md={7}>
                      <Row>
                        <Col sm={12} className="p-0">
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            {appointmentDetailReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <>
                                <Image src={CallIcon} alt="icon" />
                                <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224">
                                  {`${appointmentUpcomingDetail?.patient?.country_code} ${appointmentUpcomingDetail?.patient?.contact_number}`}
                                </div>
                              </>
                            )}
                          </Stack>
                        </Col>
                        <Col sm={12} className="p-0">
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center pt-24"
                          >
                            {appointmentDetailReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <>
                                <Image src={MailIcon} alt="icon" />
                                <div className="fs-16 lh-201 family_outfit_regular_400 fc-202224">
                                  {appointmentUpcomingDetail?.patient?.email}
                                </div>
                              </>
                            )}
                          </Stack>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col xs={12} md={12} className="p-0">
                  <div className="pt-15">
                    <Row className="p-0">
                      <Col
                        xs={12}
                        md={12}
                        lg={9}
                        xl={9}
                        className="flex items-center"
                      >
                        <Stack
                          direction="horizontal"
                          gap={5}
                          className="items-center"
                        >
                          <Stack
                            direction="horizontal"
                            gap={1}
                            className="flex items-center"
                          >
                            <div className="fs-16 lh-201 fc-998A7B family_outfit_regular_400">
                              Modality:
                            </div>
                            <div>
                              <Image
                                src={
                                  appointmentUpcomingDetail?.consultation_type ===
                                  'Hospital Visit'
                                    ? HospitalIcon
                                    : VideoCallCameraIcon
                                }
                                alt="icon"
                              />
                            </div>
                            <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                              {appointmentDetailReducer ? (
                                <Shimmer width="120px" height="20px" />
                              ) : (
                                appointmentUpcomingDetail?.consultation_type
                              )}
                            </div>
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            <Image src={CalerderIcon} alt="icon" />
                            {appointmentDetailReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                                {moment(
                                  appointmentUpcomingDetail?.appointment_date_time
                                ).format('MMMM D, YYYY')}
                              </div>
                            )}
                          </Stack>
                          <Stack
                            direction="horizontal"
                            gap={2}
                            className="items-center"
                          >
                            <Image src={ClockIcon} alt="icon" />
                            {appointmentDetailReducer ? (
                              <Shimmer width="250px" height="20px" />
                            ) : (
                              <div className="fs-16 lh-201 fc-292D32 family_outfit_medium_500">
                                {moment(
                                  appointmentUpcomingDetail?.appointment_date_time
                                ).format('hh:mmA')}
                              </div>
                            )}
                          </Stack>
                        </Stack>
                      </Col>
                      <Col
                        xs={12}
                        md={12}
                        lg={3}
                        xl={3}
                        className="flex justify-end"
                      >
                        <ReusableButton
                          fullWidth={false}
                          variant="contained"
                          color="#F5F5F5"
                          fontSize="14px"
                          fontWeight="500"
                          padding="12px 20px"
                          height="40px"
                          bgColor="#375241"
                          brColor="transparent"
                          fontFamily="outfit_medium"
                          onClick={!vedioReducer && startVideoCall}
                          loading={vedioReducer}
                        >
                          <FormattedMessage id="Start Consultation" />
                        </ReusableButton>
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </div>

            <div className="mt-16">
              <Row className="bc-FFFFFF m-0 p-24 border-1 bColor-EFE3D7 m-0">
                <Col xs={12} md={6} className="p-0">
                  <div className="fs-16 lh-252  fc-292D32 family_outfit_medium_500">
                    <FormattedMessage id="Patient’s form" />
                  </div>
                  <div className="pt-24 fs-14 lh-176 fc-998A7B family_outfit_regular_400">
                    <FormattedMessage id="Symptoms" />
                  </div>
                  <div className="fs-16 lh-201 fc-3C3C3C pt-04 family_outfit_regular_400">
                    {appointmentDetailReducer ? (
                      <Shimmer width="250px" height="20px" />
                    ) : (
                      appointmentUpcomingDetail?.symptoms &&
                      appointmentUpcomingDetail?.symptoms.length > 0 &&
                      appointmentUpcomingDetail.symptoms
                        .map((item) => item?.name)
                        .filter((name) => name)
                        .join(', ')
                    )}
                  </div>

                  {appointmentUpcomingDetail?.attachments &&
                    appointmentUpcomingDetail?.attachments.length > 0 && (
                      <>
                        <div className="mt-4 fs-14 lh-176 fc-998A7B family_outfit_regular_400">
                          <FormattedMessage id="Attachments" />
                        </div>
                        <Stack
                          direction="horizontal"
                          gap={2}
                          className="items-center pt-04"
                        >
                          {/* {appointmentUpcomingDetail?.attachments.map(
                            (item, i) => {
                              return (
                                <Image
                                  src={item?.image}
                                  alt="icon"
                                  style={{
                                    height: '130px',
                                    width: '130px',
                                    boxShadow:
                                      'rgba(0, 0, 0, 0.2) 0px 1px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 5px 0px',
                                  }}
                                />
                              );
                            }
                          )} */}
                          {imageLoading ? (
                            <Shimmer width="250px" height="20px" />
                          ) : (
                            <>
                              {images?.map((item, i) => {
                                return (
                                  <>
                                    <Zoom>
                                      <Image
                                        key={item?.id}
                                        src={item?.image}
                                        alt="icon"
                                        style={{
                                          height: '130px',
                                          width: '130px',
                                          boxShadow:
                                            'rgba(0, 0, 0, 0.2) 0px 1px 1px 0px, rgba(0, 0, 0, 0.19) 0px 1px 5px 0px',
                                        }}
                                      />
                                    </Zoom>
                                  </>
                                );
                              })}
                            </>
                          )}
                        </Stack>
                      </>
                    )}

                  <div className="mt-4 fs-14 lh-176 fc-998A7B family_outfit_regular_400">
                    <FormattedMessage id="Description" />
                  </div>
                  <div className="pt-04 fs-16 lh-201 fc-3C3C3C family_outfit_regular_400">
                    {appointmentDetailReducer ? (
                      <Shimmer width="100%" height="20px" />
                    ) : (
                      appointmentUpcomingDetail?.description
                    )}
                  </div>
                </Col>

                <Col xs={12} md={6} className="p-0">
                  <div className="fs-16 lh-252 fc-292D32 family_outfit_medium_500">
                    <FormattedMessage id="Medical History" />
                  </div>
                  {appointmentUpcomingDetail?.medical_history &&
                    appointmentUpcomingDetail?.medical_history.length > 0 &&
                    appointmentUpcomingDetail?.medical_history.map(
                      (item, index) => {
                        return (
                          <>
                            <div className="fs-14 lh-176 fc-998A7B family_outfit_regular_400 pt-24">
                              {appointmentDetailReducer ? (
                                <Shimmer width="100%" height="20px" />
                              ) : (
                                item?.question
                              )}
                            </div>
                            <div className="pt-04 fs-16 lh-201 fc-3C3C3C  family_outfit_regular_400">
                              {appointmentDetailReducer ? (
                                <Shimmer width="250px" height="20px" />
                              ) : (
                                item?.answer
                              )}
                            </div>
                          </>
                        );
                      }
                    )}
                </Col>
              </Row>
            </div>
          </>
        ) : (
          <>
            <Row>
              <Col md={6}>
                <div
                  id="local-stream"
                  style={{
                    width: '100%',
                    height: '50vh',
                  }}
                ></div>
              </Col>
              <Col md={6} className="modal-size">
                {remoteUsers.length === 0 ? (
                  <Image
                    src={DemoVedio}
                    alt="Demo Video"
                    style={{
                      width: '100%',
                      height: '50vh',
                    }}
                  />
                ) : (
                  remoteUsers.map((user, index) => (
                    <div
                      key={user.uid}
                      id={`remote-${user.uid}`}
                      style={{
                        width: '100%',
                        height: '50vh',
                      }}
                    ></div>
                  ))
                )}
              </Col>
            </Row>

            <div
              className={
                remoteUsers.length > 0
                  ? 'button-remote-length'
                  : ' button-remote'
              }
            >
              <Stack
                direction="horizontal"
                gap={4}
                className="flex items-center mt-4 justify-center h-20 bg-[#C4C4C4]"
              >
                <button onClick={toggleAudio}>
                  {isAudioEnabled ? (
                    <Image src={MicroPhoneOn} alt="icon" />
                  ) : (
                    <Image src={MicroPhoneOff} alt="icon" />
                  )}
                </button>
                <button onClick={toggleVideo}>
                  {isVideoEnabled ? (
                    <Image src={VedioOn} alt="icon" />
                  ) : (
                    <Image src={VedioOff} alt="icon" />
                  )}
                </button>
                <ReusableButton
                  fullWidth={false}
                  variant="contained"
                  color="#F5F5F5"
                  fontSize="14px"
                  fontWeight="500"
                  padding="12px 20px"
                  height="48px"
                  bgColor="#EF233C"
                  brColor="transparent"
                  fontFamily="outfit_medium"
                  onClick={endVideoCall}
                >
                  <FormattedMessage id="End Consultation" />
                </ReusableButton>
              </Stack>
            </div>
          </>
        )}
      </Col>
    </Row>
  );
};

export default UpcomingDetails;
